import React, { FC } from "react"
import { Button, createStyles, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Theme } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fullWidth: {
            width: '100%',
            marginLeft: theme.spacing(3),
        }
    }),
)

interface FormDialogProps {
    open: boolean
    title: string
    deleteText: string
    saveText: string
    onClose: () => void
    onCloseDelete: () => void
    onCloseSubmit: () => void
}

const FormDialogWithDelete: FC<FormDialogProps> = ({ onClose, onCloseSubmit, onCloseDelete, children, open, title, deleteText, saveText }) => {
    const classes = useStyles()

    return (
        <Dialog open={open} scroll="paper" maxWidth="lg" aria-labelledby="dialog-title" aria-describedby="dialog-description" className={classes.fullWidth} >
            <DialogTitle id="dialog-title">{title}</DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Annullér</Button>
                {(deleteText !== "") ? <Button onClick={() => {onCloseDelete(); onClose();}} color="primary">{deleteText}</Button> : <></>}
                <Button onClick={() => {onCloseSubmit(); onClose();}} color="primary">{saveText}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default FormDialogWithDelete
